export default {"src":"/_next/static/media/mobile_hero.4827b40d.svg","height":378,"width":364};